/* External dependencies */
import { connect } from "react-redux";

/* Internal dependencies */
import OrderPage from "../components/account/orders/OrdersPage";
import { onSearchQueryChange } from "../redux/actions/search";
import { getOrders } from "shared-frontend/redux/actions/orders";
import { getRefunds } from "shared-frontend/redux/actions/refunds";
import { getSearchQuery } from "shared-frontend/redux/selectors/entities/search";
import { getOrderTransactions } from "shared-frontend/redux/selectors/entities/orders";


export const mapStateToProps = ( state ) => {
	return {
		transactions: getOrderTransactions( state ),
		query: getSearchQuery( state ),
	};
};

export const mapDispatchToProps = ( dispatch ) => {
	return {
		onSearchChange: ( query ) => {
			dispatch( onSearchQueryChange( query ) );
		},
		// The page's own alerts now come from the subscription summary, and the invoice rows are built
		// from the orders and refunds fetched here, so the subscription collection is no longer needed.
		loadData: () => {
			dispatch( getOrders() );
			dispatch( getRefunds() );
		},
	};
};

const OrdersPageContainer = connect(
	mapStateToProps,
	mapDispatchToProps,
)( OrderPage );

export default OrdersPageContainer;
